import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { User, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, isAuthenticated } = useAuth();

  // Login has its own header. All other pages use dashboard layout or page-level headers.
  if (location.pathname !== '/login') {
    return null; // Don't render Navbar for protected routes
  }

  return (
    <nav className="ga-safe-top fixed top-0 left-0 right-0 z-50 bg-white shadow-lg border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/dashboard/grounds" className="flex items-center">
            <Logo variant="light" className="text-green-600" />
          </Link>

          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <Link 
                to="/login"
                onClick={(e) => {
                  e.preventDefault();
                  logout();
                  navigate('/login');
                }}
                className="flex items-center space-x-2 text-gray-600 hover:text-primary-600 transition-colors duration-200"
              >
                <LogOut className="h-5 w-5" />
                <span className="hidden sm:block">Logout</span>
              </Link>
            ) : (
              <Link 
                to="/login"
                className="flex items-center space-x-2 text-gray-600 hover:text-primary-600 transition-colors duration-200"
              >
                <User className="h-5 w-5" />
                <span className="hidden sm:block">Login</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
